/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProxyManagementComponent} from './proxy-management.component';
import {ChipInputModule} from '../../../shared/chip-input/chip-input.module';
import {TooltipModule} from '../../../shared/tooltip/tooltip.module';
import {NgbTypeaheadModule} from '@ng-bootstrap/ng-bootstrap';
import {LoadingSpinnerModule} from '../../../shared/loading/loading-spinner/loading-spinner.module';

@NgModule({
    declarations: [ProxyManagementComponent],
    exports: [ProxyManagementComponent],
    imports: [CommonModule, ChipInputModule, TooltipModule, NgbTypeaheadModule, LoadingSpinnerModule]
})
export class ProxyManagementModule {
}
